import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {WalletService} from '../wallet.service';
import {Constants} from 'src/app/shared/utils/constants';
import {BitgoTransaction, PerfectMoneyTransaction, SticpayTransaction} from 'src/app/models/transaction.model';
import {AppService} from '../../../app.service';
import {BankTranferTransaction} from '../../../models/transaction.model';
import {Permission} from '../../../models/permission.model';

@Component({
  selector: 'fx-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.sass'],
})
export class TransactionComponent implements OnInit, OnDestroy {
  @Input() permission: Permission;
  @Input() type: string;
  subscription: Subscription;
  data: any[] = [];
  condition: any = {
    asset: '',
    type: '',
    code: '',
    status: '',
    q: '',
  };
  pageInfo: any = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  };
  loading = false;
  status: any[] = [];
  walletCoins = Constants.WALLET_COIN;
  walletOther = Constants.WALLET_OTHER;
  params: any = {};
  constructor(
    private appService: AppService,
    private service: WalletService) {
    for (const stt in Constants.TRANSACTION_STATUS) {
      if (Constants.TRANSACTION_STATUS.hasOwnProperty(stt)) {
        this.status.push({ id: stt, name: Constants.TRANSACTION_STATUS[stt] });
      }
    }
  }

  ngOnInit(): void {
    this.searchTransaction();
  }

  searchTransaction(search?: boolean): void {
    this.pageInfo.pageIndex = 1;
    this.loading = search;
    this.params = {
      code: this.condition.code,
      asset: this.condition.asset,
      type: this.condition.type,
      status: this.condition.status,
      q: (this.condition.keyword) ? encodeURIComponent((this.condition.keyword).trim()) : this.condition.keyword,
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
    };
    this.getTransactions(this.params);
  }

  getTransactions(params: any): void {
    let obs: any;
    if (this.type === 'bitgo') {
      obs = this.service.getTransactions<BitgoTransaction>(
        params,
        this.type,
        BitgoTransaction,
      );
    } else if (this.type === 'perfect-money') {
      obs = this.service.getTransactions<PerfectMoneyTransaction>(
        params,
        this.type,
        PerfectMoneyTransaction,
      );
    } else if (this.type === 'sticpay') {
      obs = this.service.getTransactions<SticpayTransaction>(
        params,
        this.type,
        SticpayTransaction,
      );
    } else if (this.type === 'banking') {
      obs = this.service.getTransactions<BankTranferTransaction>(
        params,
        this.type,
        BankTranferTransaction,
      );
    }
    else if (this.type === 'credit-card') {
      obs = this.service.getTransactions<BankTranferTransaction>(
        params,
        this.type,
        BankTranferTransaction,
      );
    }
    this.subscription = obs.subscribe((data: any) => {
      this.loading = false;
      if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.data = data.data;
        this.pageInfo.totalRecord = data.paging.total;
      }
    });
  }

  approve(wallet: any, num: number): void {
    this.appService
      .confirm({
        title:  `Are you sure that you want to ${ num === 2 ? 'approve' : 'reject' } this record?`,
        ok: 'Yes',
        cancel: 'No',
      }).subscribe(r => {
       if (r.result) {
         this.service
           .approveWallet(this.type, {
             state: num === 2 ? 'approved' : 'rejected',
             payment_id: wallet.refId,
           })
           .subscribe(data => {
             if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
               this.appService.showSuccess(
                 `${num === 2 ? 'Approve ' : 'Reject '}Wallet Successful`,
               );
               wallet.status = data.data.status;
               wallet.approver = data.data.approved_user;
             }
           });
       }
    });
  }

  onKeyup(evt: KeyboardEvent): void {
    if (evt.keyCode === 13) {
      this.searchTransaction(true);
    }
  }

  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.params.page = page;
    this.getTransactions(this.params);
  }

  getTitle(): string {
    return this.type.replace('-', ' ');
  }

  onTriggerData(type): void {
    if (type === 'bitgo') {
      this.pageInfo.pageIndex = 1;
      const option = {
        page: this.pageInfo.pageIndex,
        page_size: this.pageInfo.pageSize,
      };
      this.service.getTransactions<BitgoTransaction>(
        option,
        'bitgo',
        BitgoTransaction,
      ).subscribe(data => {
        if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.data = data.data;
          this.pageInfo.totalRecord = data.paging.total;
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
